import { render, staticRenderFns } from "./IconArticle.vue?vue&type=template&id=19bba4ba&"
import script from "./IconArticle.vue?vue&type=script&lang=js&"
export * from "./IconArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports